var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._b({ref:"input",style:(_vm.inputStyle),attrs:{"type":"text","value":_vm.value},on:{"input":_vm.handleInput,"blur":_vm.handleBlur,"focus":_vm.handleFocus,"change":_vm.handleChange,"clear":_vm.handleClear}},'el-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }